import React from 'react';
import type { KpiCard } from '@ctd/agent-contract';
import style from '../style.module.scss';

/** What the (i) of a card reveals: the warnings that hit this answer. */
export const CardNotes: React.FC<Pick<KpiCard, 'warnings'>> = ({
    warnings,
}) => (
    <ul className={style.notes}>
        {warnings.map((text, index) => (
            <li key={`warning-${index}`} className={style.note_warning}>
                {text}
            </li>
        ))}
    </ul>
);
